import { configureStore } from '@reduxjs/toolkit';
import onboardingReducer from './onboardingSlice';
import portRequestReducer from './portRequestSlice';
import genericUpdateReducer from './genericUpdateSlice';
import createOnboardingReducer from './createOnboardingSlice';
import signedDateReducer from './signedDateSlice';
import kickoffReducer from './kickoffSlice';
import phonesReducer from './phonesSlice';
import trainingKbReducer from './trainingKbSlice';
import trainingWorkflowReducer from './trainingWorkflowSlice';
import registrationCompleteReducer from './registrationCompleteSlice';
import goLiveReducer from './goLiveSlice';

export const store = configureStore({
  reducer: {
    onboarding: onboardingReducer,
    portRequest: portRequestReducer,
    genericUpdate: genericUpdateReducer,
    createOnboarding: createOnboardingReducer,
    signedDate: signedDateReducer,
    kickoff: kickoffReducer,
    phones: phonesReducer,
    trainingKb: trainingKbReducer,
    trainingWorkflow: trainingWorkflowReducer,
    registrationComplete: registrationCompleteReducer,
    goLive: goLiveReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export default store;
